import styled from "styled-components";

export const Div = styled.div`
  position: sticky;

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
          top: calc(2 *${props.theme.spacePx(breakpoint, 6)});
    
        `;
    })}
`;

export const StickySidebar = ({ children }: { children: React.ReactNode }) => {
  return (
    <div>
      <Div>{children}</Div>
    </div>
  );
};

export default StickySidebar;
